import betData from "../localData/betData.json";
import { getFixtureDate } from "../utilities";

const enhancedBetData = {
  ...betData,
  list: betData.list.map((bet) => ({
    ...bet,
    betDate: getFixtureDate(bet.fixture_start_date_time),
  })),
  betStatusFilter: [{ id: "status", value: "" }],
};

const bets = (state = enhancedBetData, action) => {
  switch (action.type) {
    case "SET_BET_STATUS_FILTER":
      return {
        ...state,
        betStatusFilter: action.betStatus,
      };
    default:
      return state;
  }
};
export default bets;
